import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appDropdownHover]'
})
export class DropdownHoverDirective {

  public dropdownVisible: boolean;
  private hideTimeout: any;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  @HostListener('mouseenter') onMouseEnter() {
    clearTimeout(this.hideTimeout);
    this.showDropdown();
  }

  @HostListener('mouseleave', ['$event']) onMouseLeave(event: MouseEvent) {
    const relatedTarget = event.relatedTarget as HTMLElement;

    this.hideTimeout = setTimeout(() => {
      if (!this.el.nativeElement.contains(relatedTarget)) {
        this.hideDropdown();
      }
    }, 80);
  }

  private showDropdown(): void {
    const dropdown = this.findDropdown();
    if (dropdown && !this.dropdownVisible) {
      this.renderer.setStyle(dropdown, 'display', 'flex');
      this.dropdownVisible = true;
    }
  }

  private hideDropdown(): void {
    const dropdown = this.findDropdown();
    if (dropdown && this.dropdownVisible) {
      this.renderer.setStyle(dropdown, 'display', 'none');
      this.dropdownVisible = false;
    }
  }

  private findDropdown(): HTMLElement | null {
    return this.el.nativeElement.querySelector('[data-dropdown]');
  }

}
